import DataStatus from './dataStatus';

export default DataStatus;
